import { Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import TopBanner from "./components/TopBanner";
import { useNavigate } from "react-router-dom";
import Loader from "@layout/Loader";
import { resetProductsState, store } from "@services/redux/store";
import { resetStep } from "@services/redux/slices/stepSlice";
import { useDispatch, useSelector } from "react-redux";
import { useProductSlice } from "./helpers/helpers";
import { apiSend, getRoute } from "@services/axios";
import ProductType from "./components/ProductType";

const Structure = ({ profile }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const reduxDispatch = useDispatch();
  const productData = useProductSlice();

  const [selectedProduct, setSelectedProduct] = useState(
    localStorage.getItem("product") || ""
  );
  const [selectedProductType, setSelectedProductType] = useState(() => {
    try {
      const stored = localStorage.getItem("productTypeInfo");
      return stored ? JSON.parse(stored) : null;
    } catch {
      localStorage.removeItem("productTypeInfo");
      return null;
    }
  });
  const [productTypes, setProductTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(false);

  // Fetch product types
  useEffect(() => {
    const fetchProductTypes = async () => {
      try {
        const res = await apiSend(getRoute("AUTOCOMPLETE_PRODUCT_TYPE"), "get");
        if (res?.data?.result) setProductTypes(res.data.result);
      } catch (err) {
        console.error("Error fetching product types:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProductTypes();
  }, []);

  const handleChoice = (item) => {
    const capitalizedValue =
      item?.value?.charAt(0).toUpperCase() + item?.value?.slice(1);
    setSelectedProduct(capitalizedValue);
    setSelectedProductType({
      id: item.id,
      name: item.name,
      icon: item.icon,
      value: item.value,
    });
  };

  const handleNextClick = () => {
    if (!selectedProduct) return;

    const savedType = localStorage.getItem("product");
    const hasExistingData = productData?.step1?.name?.trim() !== "";

    // Warn user if changing product type
    if (savedType && savedType !== selectedProduct && hasExistingData) {
      if (!window.confirm(t("product_change_warning"))) return;
    }

    // Save selected product type
    localStorage.setItem("product", selectedProduct);
    localStorage.setItem(
      "productTypeInfo",
      JSON.stringify(selectedProductType)
    );

    // Reset Redux if product changed
    if (savedType !== selectedProduct) {
      store.dispatch(resetProductsState());
      reduxDispatch(resetStep());
    }

    // Show loader and navigate
    setShowLoader(true);
    setTimeout(() => navigate("/new-product/form"), 100);
  };

  if (loading || showLoader) return <Loader />;

  return (
    <div >
      <TopBanner step={1} />
      <section className="container position-relative form-transition pb-5 mb-3">
       
            <div className="bg-white p-4 rounded-4">
              <h2 className="fs-3 lh-base fw-medium text-dark">
                {t("product_type_question")}
              </h2>
              <p className="fs-5 fw-light">
                {t("product_type_question_caption")}
              </p>
              <ProductType
                data={productTypes}
                handleChoice={handleChoice}
                selectedChoice={selectedProductType?.id}
              />
            </div>
        
      </section>

      {/* <div
        className="bg-white w-100 border-top overflow-x-hidden"
        style={{ position: "fixed", bottom: 0, zIndex: 4 }}
      > */}
       <div
        className="bg-white  border-top "
        style={{   zIndex: 4 }}
      >
        <div className="container py-3 ">
          <Row className="justify-content-between align-items-center">
            <Col xs="12"
              sm="4"
              md="3"
              lg="2">
              <button
                type="button"
                className="bg-white fs-5 fw-bold text-decoration-underline text-dark"
                onClick={() => navigate(-1)}
              >
                {t("back")}
              </button>
            </Col>
            <Col
              xs="12"
              sm="4"
              md="3"
              lg="2"
              className="d-flex justify-content-end"
            >
              <button
                type="button"
                className='fs-6 btn-blue py-3 w-100 rounded-5 text-white'
                onClick={handleNextClick}
              >
                {t("next")}
              </button>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Structure;
